/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpLogger from '@module-logger/mbp';

import snipeListData from '../static_data/snipeListData';

const brandImagePaths = {
    1001: { // Flowers
        domain: 'https://cdn1.1800flowers.com',
        path: '/wcsstore/Flowers/images/catalog/',
        defaultImg: '//cdn1.1800flowers.com/wcsstore/RAPIDStorefrontAssetStore/images/flowers.png',
    },
    1002: { // TPF
        domain: 'https://cdn1.thepopcornfactory.com',
        path: '/wcsstore/ThePopcornFactory/images/catalog/',
        defaultImg: '//cdn1.thepopcornfactory.com/wcsstore/RAPIDStorefrontAssetStore/images/popcorn.png',
    },
    1009: { // Baskets
        domain: 'https://cdn1.1800baskets.com',
        path: '/wcsstore/Baskets/images/catalog/',
        defaultImg: '//cdn1.1800baskets.com/wcsstore/RAPIDStorefrontAssetStore/images/baskets.png',
    },
    1010: { // Fruit
        domain: 'https://cdn1.1800flowers.com',
        path: '/wcsstore/Flowers/images/catalog/',
        defaultImg: '//cdn1.fruitbouquets.com/wcsstore/FruitBouquet/images/fruitbouquets-logo.png',
    },
    1012: { // Cheryls
        domain: 'https://cdn1.cheryls.com',
        path: '/wcsstore/CherylAndCompany/images/catalog/',
        defaultImg: '//cdn1.cheryls.com/wcsstore/RAPIDStorefrontAssetStore/images/cheryls.png',
    },
    1016: { // FannieMay
        domain: 'https://cdn1.cheryls.com',
        path: '/wcsstore/FannieMay/images/catalog/',
        defaultImg: '//cdn1.cheryls.com/wcsstore/RAPIDStorefrontAssetStore/images/cheryls.png',
    },
    1018: { // SY
        domain: 'https://cdn1.stockyards.com',
        path: '/wcsstore/StockYards/images/catalog/',
        defaultImg: '//cdn1.harryanddavid.com/wcsstore/StockYards/images/Stockyards_logo_new.png',
    },
    1019: { // HD
        domain: 'https://cdn1.harryanddavid.com',
        path: '/wcsstore/HarryAndDavid/images/catalog/',
        defaultImg: '//cdn1.harryanddavid.com/wcsstore/RAPIDStorefrontAssetStore/images/harry.png',
    },
    1020: { // WF
        domain: 'https://cdn1.1800flowers.com',
        path: '/wcsstore/Wolfermans/images/catalog/',
        defaultImg: '//cdn1.wolfermans.com/wcsstore/RAPIDStorefrontAssetStore/images/wolf.png',
    },
    1027: { // WF
        domain: 'https://cdn1.1800flowers.com',
        path: '/wcsstore/TheMarket/images/catalog/',
        defaultImg: '//cdn1.1800flowers.com/wcsstore/RAPIDStorefrontAssetStore/images/themarket.png',
    },
    1022: { // PZU
        domain: 'https://cdn1.personalizationuniverse.com',
        path: '/wcsstore/PersonalizationUniverse/images/catalog/',
        defaultImg: '//cdn1.personalizationuniverse.com/wcsstore/RAPIDStorefrontAssetStore/images/personalization_universe_logo.png',
    },
    1025: { // SCH
        domain: 'https://cdn1.simplychocolate.com',
        path: '/wcsstore/SimplyChocolate/images/catalog/',
        defaultImg: '//cdn1.simplychocolate.com/wcsstore/RAPIDStorefrontAssetStore/images/simplychocolate.png',
    },
    1034: { // fl
        domain: 'https://cdn1.florists.com', // update when information is available
        defaultImg: '//cdn1.florists.com/wcsstore/RAPIDStorefrontAssetStore/images/florists.png', // update when information is available
        path: '/wcsstore/Florists/images/catalog/', // update when information is available
    },
};

const getBaseImageName = (nonFloralBrands, product) => {
    let baseImageName = '';
    if (product.x_altImageName) {
        baseImageName = product.x_altImageName;
    }
    if (product.x_brand_id && nonFloralBrands && !nonFloralBrands.includes(product.x_brand_id)) {
        if (product.x_default_sku_img) {
            baseImageName = product.x_default_sku_img;
        } else if (product.x_minseq_sku) {
            baseImageName = product.x_minseq_sku;
        } else if (product.thumbnail) {
            baseImageName = product.thumbnail;
        }
    } else { /* eslint no-param-reassign: "off", no-lonely-if: "off" */
        if (product.thumbnail) {
            const temp = product.thumbnail.split('/');
            baseImageName = temp[temp.length - 1];
        } else {
            if (product.partNumber && product.partNumber.indexOf('-') !== -1) {
                baseImageName = product.x_item_number;
            } else if (product.partNumber) {
                baseImageName = product.partNumber;
            }
        }
    }
    return baseImageName;
};

export const getProductImageURLs = ({
    brand, product,
    typeImg, nonFloralBrands,
}) => {
    let imageUrl = '';
    let brandId = product.x_brand_id;
    let snipeText = '';
    const listImages = [];

    // Set Brand ID
    if (brand && brand.id && !product.x_brand_id) {
        brandId = brand.id;
    }

    // Set Image url base on type (Club, CYO, Default)
    if (product.x_product_type_field5 === 'CLUB') {
        imageUrl = `${brandImagePaths[brandId].domain}${brandImagePaths[brandId].path}${getBaseImageName(nonFloralBrands, product)}x.jpg`;
    } else if (brandId && brandImagePaths[brandId]) {
        let codeImage = 'x';

        if (typeImg === 'small' || typeImg === 'cyoItem') {
            codeImage = 'c';
        } else if (typeImg === 'cyo') {
            codeImage = 't';
        }
        if (typeImg !== 'cyo') {
            if (product.x_snipeimage) {
                const getSnipe = snipeListData(product.x_snipeimage);
                snipeText = getSnipe.snipe;
                // snipeClass = getSnipe.class; // TODO: This must remain outside the helper, and be deteremined by the consuming component/method
                if (product.x_snipeimage === snipeText) {
                    snipeText = null;
                }
            }
        }

        imageUrl = `${brandImagePaths[brandId].domain}${brandImagePaths[brandId].path}${getBaseImageName(nonFloralBrands, product)}${codeImage}.jpg`;
    }

    if (imageUrl) {
        // const defaultImg = `${brandImagePaths[brandId].defaultImg}`;

        let altData = '';
        if (product.name) {
            altData = product.name;
        } else if (product.description && product.description.name) {
            altData = product.description.name;
        }

        if (altData) {
            altData = altData.replace(/[^a-zA-Z ]/g, '');
        }

        // Default image set (single)
        listImages.push({
            src: imageUrl,
            alt: altData,
        });

        // Alt Image set (multiples)
        if (!typeImg || typeImg === 'big' || (typeImg !== 'small' && typeImg !== 'cyoItem' && typeImg === 'cyo')) {
            try {
                if (product.x_alt_image && (Array.isArray(product.x_alt_image) && product.x_alt_image.length)) {
                    product.x_alt_image.forEach((itemImg) => {
                        listImages.push({
                            src: `${brandImagePaths[brandId].domain}${brandImagePaths[brandId].path}${itemImg}x.jpg`,
                            alt: altData,
                        });
                    });
                } else if (product.x_alt_image) {
                    listImages.push({
                        src: `${brandImagePaths[brandId].domain}${brandImagePaths[brandId].path}${product.x_alt_image}x.jpg`,
                        alt: altData,
                    });
                }
            } catch (ex) {
                mbpLogger.logError({
                    imageUrl,
                    appName: process.env.npm_package_name,
                    module: 'mbp-pwa-ui',
                    function: 'getProductImageURLs',
                    message: 'Failed to get image URLs',
                });
            }
        }
    }

    return listImages;
};

export const isProductAvailable = (product) => product?.availability?.availabilityIndicator === 'true';

export const isProductPublished = (product) => product?.availability?.published || false; // returning bool in gql

export const getPrice = (price) => {
    let display;
    let offer;

    price.forEach((row) => {
        switch (row.usage) {
            case 'Display':
                display = Number(row.value);
                break;
            case 'Offer':
                offer = Number(row.value);
                break;
            default:
                mbpLogger.logError({
                    priceRow: row,
                    appName: process.env.npm_package_name,
                    module: 'mbp-pwa-ui',
                    function: 'getPrice',
                    message: `Price row usage ${row.usage} not valid.`,
                });
                break;
        }
    });

    // if (!offer > 0) {
    //     return parseFloat(display).toFixed(2);
    // }

    // if (offer < display) {
    //     return parseFloat(offer).toFixed(2);
    // }

    // if (display) {
    //     return parseFloat(display).toFixed(2);
    // }

    return {
        display: parseFloat(display).toFixed(2),
        offer: parseFloat(offer).toFixed(2),
    };
};
